import React, { PureComponent } from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Collapse } from 'reactstrap';
import TopbarMenuLink from './TopbarMenuLink';
import TopbarMenuButton from './TopbarMenuButton';
import store from '../../App/store';
import { logout } from '../../../redux/actions/loginActions';
import { changeUserViewAs } from '../../../redux/actions/sidebarActions';

const Ava = `${process.env.PUBLIC_URL}/img/avatar.png`;

class TopbarProfile extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };

  constructor() {
    super();
    this.state = {
      collapse: false,
    };
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  onLogoutClick = () => {
    const { history } = this.props;
    store.dispatch(changeUserViewAs(0));
    store.dispatch(logout());
    history.push('/');
  };

  render() {
    const { collapse } = this.state;

    const currentUser = JSON.parse(localStorage.getItem('currentUser')) || {};
    const LoggedUser = (
      <p className="topbar__avatar-name">{currentUser.fullName}</p>
    );
    const AnonimousUser = (
      <p className="topbar__avatar-name">Usuario an&oacute;nimo</p>
    );

    return (
      <div className="topbar__profile">
        <button type="button" className="topbar__avatar" onClick={this.toggle}>
          <img className="topbar__avatar-img" src={Ava} alt="avatar" />
          {currentUser.isAuthenticated ? LoggedUser : AnonimousUser}
          <DownIcon className="topbar__icon" />
        </button>
        {collapse && <button type="button" className="topbar__back" onClick={this.toggle} />}
        <Collapse isOpen={collapse} className="topbar__menu-wrap">
          <div className="topbar__menu">
            <TopbarMenuLink title="Mi Perfil" icon="list" path="/pages/account/my-profile" />
            <TopbarMenuLink title="Mis Materias" icon="list" path="/pages/student-subjects" />
            <TopbarMenuLink title="Mi Malla" icon="inbox" path="/pages/two" />
            <div className="topbar__menu-divider" />
            <TopbarMenuButton title="Salir" icon="exit" onClick={this.onLogoutClick} path="#" />
          </div>
        </Collapse>
      </div>
    );
  }
}

export default withRouter(TopbarProfile);
